if (!customElements.get('s4-mapping-carousel')) {
  customElements.define(
    's4-mapping-carousel',
    class S4MappingCarousel extends HTMLElement {
      constructor() {
        super();
        this.sliderInstance = false;
      }

      connectedCallback() {
        if (!window.FoxTheme || !window.FoxTheme.Carousel) return;

        this.swiperEl = this.querySelector('.swiper');
        if (!this.swiperEl) return;

        this.wrapper = this.swiperEl.querySelector('.swiper-wrapper');
        if (!this.wrapper || !this.wrapper.children.length) return;

        const nextEl = this.querySelector('.swiper-button-next');
        const prevEl = this.querySelector('.swiper-button-prev');
        const pagination = this.querySelector('.swiper-pagination');

        const space = parseFloat(this.dataset.space) || 16;
        const useArrows = this.dataset.arrows === 'true';
        const useDots = this.dataset.dots === 'true';
        const loop = this.dataset.loop === 'true';

        const options = {
          slidesPerView: 'auto',
          spaceBetween: space,
          threshold: 2,
          watchOverflow: true,
          loop: loop,
          navigation: useArrows && nextEl && prevEl ? { nextEl, prevEl } : false,
          pagination: useDots && pagination ? { el: pagination, clickable: true } : false,
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this.swiperEl, options);
        this.sliderInstance.init();
      }

      disconnectedCallback() {
        if (this.sliderInstance && this.sliderInstance.slider) {
          try {
            this.sliderInstance.slider.destroy(true, true);
          } catch (e) {}
        }
      }
    }
  );
}
